import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService} from './local-storage.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  title = 'bhakts-admin';

  constructor(private localStorage: LocalStorageService, private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit(): void {
    // if (localStorage.getItem('bhakts')) {
    //   this.router.navigateByUrl('/home');
    // } else {
    //   this.router.navigateByUrl('/login');
    // }
  }
}
